<template>
    <div class="footer">
        <p>© 2021 Zoom Video Communications, Inc. All rights reserved.</p>
    </div>
</template>
<script>
export default {
    name: 'Footer'
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.footer {
    // position: absolute;
    // margin-left: 160px;
    // margin-top: 50px;
    text-align: center;
    color: #666;
    font-size: 14px;
    // padding-top: 10px;
    height: 30px;
    width: 100%;
    bottom: 0;
    border-top: 1px solid #d8dce5;
    position: fixed;
    background-color: #fff;
    z-index: 1002;
    padding-bottom: 12px;
    // margin: -30px auto 0;
}
</style>
